// Google Drive
export const GOOGLE_DRIVE_STATIC_SUGGESTIONS: string[] = [
	'Show me my recent files',
	'List files I worked on recently',
	'Find files I edited this week',
	'Files I updated in the last 7 days',
	'My files from the last 14 days',
	'My files older than 2 months',
	'Show my files from this year',
	'Show me my recent Google docs',
	'My newest Google docs',
	'My Google docs from this week',
	'Google docs I worked on',
	'Google docs I updated yesterday',
];
